<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <input
                        v-model="search.name"
                        class="form-control mr-sm-2"
                        type="search"
                        placeholder="รายการ"
                        aria-label="Search"/>
                    &nbsp
                    <button class="btn btn-success my-2 my-sm-0"
                            type="button"
                            @click="searchBonusSale">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp
                    <button class="btn btn-warning my-2 my-sm-0"
                            @click="showBonusSaleFeeModal"
                            type="button">
                        <icon name="plus"></icon>
                        เพิ่มโบนัสเซลล์
                    </button>
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">รายการ</th>
                    <th scope="col">ยอดขายตั้งแต่</th>
                    <th scope="col">ถึง</th>
                    <th scope="col">โบนัส(บาท)</th>
                    <th scope="col">วัน/เดือน/ปี ที่แก้ไข</th>
                    <th scope="col">ผู้บันทึก</th>
                    <th scope="col">แกไข / ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in rateBonusList">
                    <td>{{ ((dataPaginate.current_page - 1) * 10) + (index + 1) }}</td>
                    <td>{{ data.name }}</td>
                    <td>{{ data.start_price | currency }}</td>
                    <td>{{ data.end_price | currency }}</td>
                    <td>{{ data.bonus | currency }}</td>
                    <td>{{ data.updated_at | moment("DD/MM/YYYY") }}</td>
                    <td>
                        <template v-if="data.user">
                            {{ data.user.name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <a @click="editBonusSale(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                        &nbsp&nbsp
                        <a @click="showDeleteModal(data.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <br>
        <div v-if="rateBonusList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getBonusSale">

            </vue-pagination>
        </div>
        <!--add rate_bonus_sale-->
        <b-modal size="lg" hide-footer hide-header ref="add_bonus_sale">
            <div>
                <sale-bonus-modal @submit="submitBonusSale"></sale-bonus-modal>
            </div>
        </b-modal>
        <!--edit rate_bonus_sale-->
        <b-modal size="lg" hide-footer hide-header ref="edit_bonus_sale">
            <div>
                <h2 style="text-align: center">ตั้งค่าโบนัสเซลล์</h2>
                <br/>
                <div class="form-group row">
                    <div class="col-sm-3 text-right">
                        <label>ชื่อรายการ</label>
                    </div>
                    <div class="col-sm-7">
                        <input class="form-control"
                               type="text" v-model="form.name"/>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-3 text-right">
                        <label>ยอดขาย ตั้งแต่</label>
                    </div>
                    <div class="col">
                        <input type="text"
                               placeholder="จำนวนเริ่มต้น"
                               class="form-control" v-model="form.start_price"/>
                    </div>
                    <div class="col">
                        <input type="text"
                               placeholder="จำนวนสิ้นสุด"
                               class="form-control" v-model="form.end_price"/>
                    </div>
                    <div class="col">
                        <input type="text"
                               placeholder="โบนัส"
                               class="form-control" v-model="form.bonus"/>
                    </div>
                    <div class="col"></div>
                </div>
                <div class="col text-center">
                    <button type="button" @click="saveEditBonusSale"
                            class="btn btn-success">
                        <icon name="save"></icon>
                        บันทึก
                    </button>
                    &nbsp&nbsp
                    <button type="button" @click="hideEditBonusSaleModal"
                            class="btn btn-outline-secondary">
                        <icon name="times"></icon>
                        ยกเลิก
                    </button>
                </div>
            </div>
        </b-modal>
        <!--b-modal delete-->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button type="button"
                        @click="deleteBonusSale"
                        class="btn btn-success">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button type="button"
                        @click="hideDeleteModal"
                        class="btn btn-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!--<pre class="alert alert-primary">{{rateBonusList}}</pre>-->
    </div>
</template>

<script>
import SaleBonusModal from "./SaleBonusModal";
import {mapState} from "vuex"
import VuePagination from "../../../Pagination";

export default {
    components: {
        VuePagination,
        SaleBonusModal
    },
    name: "sale-bonus",
    created() {
        this.$store.dispatch("RateBonusSale/setRateBonusSale");
    },
    data() {
        return {
            delete_id: "",
            event_submit: false,
        }
    },
    computed: {
        ...mapState({
            rateBonusList: state => {
                return state.RateBonusSale.rateBonusList;
            },
            form: state => {
                return state.RateBonusSale.rateBonusForm;
            },
            user: state => {
                return state.Auth.user
            },
            search: state => {
                return state.RateBonusSale.search;
            },
            dataPaginate: state => {
                return state.RateBonusSale.dataPaginate;
            },
        })
    },
    methods: {
        showBonusSaleFeeModal() {
            this.$store.dispatch("RateBonusSale/clearDataForm");
            this.$refs.add_bonus_sale.show();
        },
        hideBonusSaleModal() {
            this.$refs.add_bonus_sale.hide();
        },
        showDeleteModal(id) {
            this.delete_id = id;
            this.$refs.delete_item.show();
        },
        hideDeleteModal() {
            this.$refs.delete_item.hide();
        },
        showEditBonusSaleFeeModal() {
            this.$refs.edit_bonus_sale.show();
        },
        hideEditBonusSaleModal() {
            this.$refs.edit_bonus_sale.hide();
        },
        submitBonusSale(submitData) {
            //console.log(submitData);
            this.hideBonusSaleModal();
            this.$store.dispatch("RateBonusSale/setRateBonusSale");
        },
        editBonusSale(id) {
            this.showEditBonusSaleFeeModal();
            this.$store.dispatch("RateBonusSale/show", id)
        },
        saveEditBonusSale() {
            this.form.user_id = this.user.id;
            this.$store.dispatch("RateBonusSale/save", {
                id: this.form.id,
                data: this.form
            }).then(() => {
                this.hideEditBonusSaleModal();
                this.$store.dispatch("RateBonusSale/setRateBonusSale");
            })
        },
        deleteBonusSale() {
            this.$store.dispatch("RateBonusSale/delete", this.delete_id).then(() => {
                this.$store.dispatch("RateBonusSale/setRateBonusSale");
            });
            this.hideDeleteModal();
        },
        searchBonusSale() {
            this.event_submit = true;
            this.$store.dispatch("RateBonusSale/search", this.search)
        },
        getBonusSale() {
            const page = this.dataPaginate.current_page;

            let data = {
                page: page,
                name: this.search.name,
            }
            //paginate search
            if (this.event_submit) {
                this.$store.dispatch('RateBonusSale/search', data)
            }
            //paginate get data
            else {
                this.$store.dispatch('RateBonusSale/setRateBonusSale', page)
            }
        }

    }
}
</script>

<style scoped>

</style>
